import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, Input, OnDestroy, OnInit } from "@angular/core";
import { WebhookFormInputComponent } from "../webhook-form-input/webhook-form-input.component";
import { WebhookCommonComponent } from "../common.components";

@Component({
    selector: 'webhook-form-date',
    templateUrl: './webhook-form-date.component.html',
    styleUrl: './webhook-form-date.component.scss',
    standalone: false
})

export class WebhookFormDateComponent extends WebhookCommonComponent implements OnInit, OnDestroy {
   
    
   


}